// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SXk30iD6nr9dkaMKX7dS.ant-select {\n\twidth: 115px;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/cargos/helpers/styles.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb","sourcesContent":[".settlementSelect:global(.ant-select) {\n\twidth: 115px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settlementSelect": "SXk30iD6nr9dkaMKX7dS"
};
export default ___CSS_LOADER_EXPORT___;
